import ListItem from './ListItem';

export default function NavbarDropdownCard({
  icon,
  title,
  description,
  href,
  target,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
  href: string;
  target?: string;
}) {
  return (
    <div className="flex items-center gap-4 font-light">
      <div className="border-gray rounded-md border p-4">{icon}</div>
      <ListItem key={title} title={title} href={href} target={target}>
        {description}
      </ListItem>
    </div>
  );
}
